import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
  makeStyles,
} from '@material-ui/core'
import statsTableStyles from './statsTable.styles'
import StatsTableHeader from './StatsTableHeader'
import {
  STATS_GROUPS,
  flattenLeaves,
  totalCells,
  averageCells,
} from '../../utils/constants/playerStatsColumnGroups'
import {
  getVisibleFederationLeaves,
  filterFederationGroups,
} from '../../utils/helpers/displayStatsMapping'

const useStyles = makeStyles(statsTableStyles)

const PlayerSeasonSummaryTable = ({ totals, averages, displayStats }) => {
  const classes = useStyles()
  const totalRow = totalCells(totals)
  const averageRow = averageCells(averages)

  const visibleLeafKeys = getVisibleFederationLeaves(displayStats)
  const groups = filterFederationGroups(STATS_GROUPS, visibleLeafKeys)
  const LEAVES = flattenLeaves(groups)

  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table size='small'>
        <StatsTableHeader groups={groups} leftHeader='' />
        <TableBody>
          <TableRow hover>
            <TableCell className={classes.leftCell}>
              <Typography className={classes.summaryLabel}>Total</Typography>
            </TableCell>
            {LEAVES.map(leaf => (
              <TableCell
                key={leaf.key}
                className={classnames(classes.cell, {
                  [classes.categoryBorderLeft]: leaf.firstOfGroup,
                })}
              >
                {totalRow[leaf.key]}
              </TableCell>
            ))}
          </TableRow>
          <TableRow className={classes.summaryRow} hover>
            <TableCell className={classes.leftCell}>
              <Typography className={classes.summaryLabel}>Average</Typography>
            </TableCell>
            {LEAVES.map(leaf => (
              <TableCell
                key={leaf.key}
                className={classnames(classes.cell, {
                  [classes.categoryBorderLeft]: leaf.firstOfGroup,
                })}
              >
                {averageRow[leaf.key]}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

PlayerSeasonSummaryTable.propTypes = {
  totals: PropTypes.object,
  averages: PropTypes.object,
  displayStats: PropTypes.array,
}

export default PlayerSeasonSummaryTable
